import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFloating from "./WhatsAppFloating";
import StickyContact from "./StickyContact";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  const isAdmin = pathname.startsWith("/admin");

  return (
    <div className="min-h-screen bg-[#050505] text-white overflow-x-hidden">
      <a href="#main-content" className="skip-to-content">Skip to content</a>
      <Header />
      <main id="main-content" tabIndex="-1" className="pt-20 pb-24 lg:pb-0">{children}</main>
      <Footer />
      {/* Floating WhatsApp chat (replaces previous Aria live-chat bubble). */}
      {!isAdmin && <WhatsAppFloating />}
      {!isAdmin && <StickyContact />}
    </div>
  );
}
